<template>
    <div style="background-color: #fafafa;">
        <van-tabs v-model="selected" type="line" sticky @click="switchTab">
            <van-tab title="客户"></van-tab>
            <van-tab title="公海" v-if="checkNavigationMenu('公海管理')"></van-tab>
        </van-tabs>
        <van-search shape="round" v-model="value" placeholder="请输入搜索关键词" show-action>
            <div slot="action" @click="onSearch">搜索</div>
        </van-search>
        <div v-if="filterable" class="tagDiv">
            <van-dropdown-menu>
                <van-dropdown-item v-model="customerBelong" :options="belongOption" @change="onSearch"/>
                <van-dropdown-item v-model="stage" :options="stageOption" @change="onSearch"/>
            </van-dropdown-menu>
        </div>
        <select-staff :callback="assign" v-model="show"></select-staff>
        <van-pull-refresh v-model="refreshing" @refresh="onSearch">
            <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
                <div v-for="customer in list" class="card" :key="customer.uuid" @click="detail(customer.uuid)">
                    <table class="layout">
                        <tr>
                            <td class="avatar-box" rowspan="4">
                                <img :src="avatarUrl + customer.advisorIdavatar" class="avatar" alt="avatar">
                                <p class="advisor">{{customer.advisorIdname}}</p>
                            </td>
                            <td colspan="2">
                                <div class="header">
                                    <span class="title">{{customer.name}}</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="content">
                                <p v-for="field in displayField" :key="field.fieldName">
                                    <span :class="icon + field.appIcon"></span>
                                    <span>{{customer[field.dictionary ? field.fieldName+'name':field.fieldName] || '无'}}</span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <van-icon name="records" v-if="customer.advisorId === userId && filterable"
                                          @click="addContact(customer,$event)"/>
                                <van-icon name="clock-o" v-if="filterable" @click="getContactList(customer,$event)"/>
                                <van-icon name="phone-o" v-if="filterable" @click="call(customer.mobile,$event)"/>
                                <van-icon name="exchange" v-if="checkPermission('批量分配客户')"
                                          @click="selectUser(customer.uuid,$event)"/>
                                <van-icon name="aim" v-if="!filterable" @click="extractCustomer(customer.uuid,$event)"/>
                            </td>
                        </tr>
                    </table>
                </div>
            </van-list>
        </van-pull-refresh>
        <div class="btn-create" @click="createCustomer">+</div>
    </div>
</template>
<script>
    import {Tab, Tabs, Panel, List, Search, PullRefresh, Tag, DropdownMenu, DropdownItem, Toast, Icon} from 'vant';
    import userInfo from '../store/userInfo';
    import {API_URL} from "../common/config";
    import moment from "moment";
    import {formatDictionary} from "../utils/dictionary";
    import customerService from "../service/customerService";
    import fieldDescriptionService from "../service/fieldDescriptionService";
    import selectStaff from "../components/SelectStaff";

    export default {
        data: function () {
            return {
                selected: 0,
                type: 0,
                list: [],
                displayField: [],
                loading: false,
                finished: false,
                filterable: true,
                show: false,
                searchParam: {},
                pageIndex: 0,
                dictionaryName: '',
                value: '',
                colorGray: '#c1c1c1',
                colorRed: '#ff7f66',
                customerId: '',
                customerBelong: null,
                refreshing: false,
                belongOption: [
                    {text: '全部客户', value: null},
                    {text: '我的客户', value: 'myCustomer'},
                    {text: '共享给我的客户', value: 'shareCustomer'},
                    {text: '下属的客户', value: 'subordinateCustomer'}
                ],
                stageOption: [
                    {text: '阶段', value: null}
                ],
                stage: null
            }
        },
        store: userInfo,
        components: {
            selectStaff,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Tag.name]: Tag,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [PullRefresh.name]: PullRefresh,
            [DropdownMenu.name]: DropdownMenu,
            [Icon.name]: Icon,
            [DropdownItem.name]: DropdownItem
        },
        computed: {
            userId() {
                return this.$store.getters.getUserId;
            },
            avatarUrl() {
                return API_URL + "/oa/common/attachment/showImage?id=";
            },
            icon() {
                return "iconfont ";
            }
        },
        created: async function () {
            this.searchParam = await fieldDescriptionService.getSearchParam("crm_customer");
            let resp = await customerService.getStage();
            if (resp.data.Status === '1') {
                this.stageOption = this.stageOption.concat(...resp.data.Data.map(item => {
                    return {text: item.name, value: item.uuid};
                }));
            }
        },
        methods: {
            async onLoad() {
                if (this.displayField.length < 1) {
                    let displayField = await fieldDescriptionService.getFieldDisplayOnAPP("crm_customer");
                    if (displayField.data.Status === "1") {
                        this.displayField = displayField.data.Data;
                    }
                }
                if (!this.dictionaryName) {
                    let displayField = await fieldDescriptionService.getDictionaryName("crm_customer");
                    if (displayField.data.Status === "1") {
                        this.dictionaryName = displayField.data.Data;
                    }
                }
                this.pageIndex++;
                let resp = await customerService.getList(this.pageIndex, this.value, this.dictionaryName, this.searchParam,
                    this.customerBelong, this.type, this.stage);
                if (resp.data.Status === "1") {
                    resp.data.Data.data.forEach(customer => {
                        customer.createTime = moment(customer.createTime).format('YYYY-MM-DD');
                        customer.birthday = customer.birthday === undefined ? "" : moment(customer.birthday).format('YYYY-MM-DD');
                    });
                    formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [...this.list, ...resp.data.Data.data];
                    this.finished = resp.data.Data.total <= this.list.length;
                }
            },
            onSearch() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
            call(mobile, e) {
                e.stopPropagation();
                window.location.href = 'tel:' + mobile;
            },
            switchTab(tabIndex) {
                window.scrollTo(0, 0);
                this.type = tabIndex;
                this.filterable = tabIndex === 0;
                this.onSearch()
            },
            async selectUser(customerId, e) {
                e.stopPropagation();
                this.show = true;
                this.customerId = customerId;
            },
            async assign(staffId) {
                let staffIds = localStorage.getItem("staffIds");
                if (staffIds === undefined || staffIds === null) {
                    localStorage.setItem("staffIds", staffId);
                } else {
                    if (staffIds.split(staffId).length === 1) {
                        staffIds = staffIds + "," + staffId;
                        localStorage.setItem("staffIds", staffIds);
                    }
                }
                let resp = await customerService.assign(this.customerId, staffId);
                if (resp.data.Status === '1') {
                    Toast.success('分配成功');
                    this.show = false;
                    this.onSearch();
                } else {
                    Toast.fail(resp.data.Message);
                }
            },
            async extractCustomer(customerId, e) {
                e.stopPropagation();
                let resp = await customerService.extract(customerId);
                if (resp.data.Status === '1') {
                    Toast.success('提取成功');
                    this.onSearch();
                } else {
                    Toast.fail(resp.data.Message);
                }
            },
            detail(uuid) {
                window.open(API_URL + "/crm/html/customer/detail?uuid=" + uuid);
            },
            getContactList(customer, e) {
                e.stopPropagation();
                window.open(API_URL + "/crm/html/contact/contactTile?id=contactDetailList&customerId=" + customer.uuid + "&customerName=" + customer.name);
            },
            addContact(customer, e) {
                e.stopPropagation();
                window.open(API_URL + "/crm/html/contact/detail?uuid=0&contactType=customerContact&customerId=" + customer.uuid + "&customerName=" + customer.name);
            },
            createCustomer() {
                window.open(API_URL + "/crm/html/customer/create");
            }
        }
    };
</script>

<style scoped>
    .icon {
        margin-left: 1rem;
    }

    .van-popup--right {
        width: 100%;
        height: 100%;
    }

    .van-icon {
        margin-right: 0.6rem;
        color: #4090FA;
    }
</style>